import { useTranslation } from '../../core/hooks/use-translation';
import { EmptyState } from '../../ui/empty-state';
import { Panel } from '../../ui/panel';
import { CalendarIcon } from '../../ui/portal-icons';
import { AppointmentCard } from './appointment-card';
import { usePortalOutlet } from './use-portal-outlet';

/**
 * Every consultation the customer has. One still ahead of them can be cancelled here; moving one is
 * a question on the messages tab, because the booking path's capacity checks belong to staff.
 */
export function AppointmentsTab() {
    const { t } = useTranslation();
    const { appointments, recordAppointmentCancelled } = usePortalOutlet();

    return (
        <Panel title={t('portal.appointments')} icon={<CalendarIcon />}>
            {appointments.length === 0 ? (
                <EmptyState icon={<CalendarIcon />} title={t('portal.no_appointments')}>
                    {t('portal.no_appointments_hint')}
                </EmptyState>
            ) : (
                <ul className="space-y-3">
                    {appointments.map((appointment) => (
                        <AppointmentCard
                            key={appointment.id}
                            appointment={appointment}
                            onCancelled={recordAppointmentCancelled}
                        />
                    ))}
                </ul>
            )}
        </Panel>
    );
}
